import { Component, OnInit } from '@angular/core';
import { Usuario,RegistroService,Planteles,Cargos} from 'src/app/services/registro.service';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { ignoreElements } from 'rxjs/operators';

@Component({
  selector: 'app-cambiocontrasena',
  templateUrl: './cambiocontrasena.component.html',
  styleUrls: ['./cambiocontrasena.component.css']
})
export class CambiocontrasenaComponent implements OnInit {
  usuario: Usuario={
    email:'',
    nombre:'',
    password:'',
    cargo:0,
    plantel:'',
    numemp:0,
    idplantel:0 

  };

  bandera=false;

  cargo:any;
   correo:any;

  ListarEquipo: Planteles[] = [];
  Cargos: Cargos[] = [];

  constructor(private registro:RegistroService,private msj:mensajeSesionExpiradaService,private router:Router) { }

  ngOnInit(): void {
    this.verificarcargo();

  }

///////////////metodo actualiza contraseña//////////////////////////  
actualizarPassword(form:NgForm,email:any,password:any){
  
    if(form.invalid){
      console.log('Formulario Invalido');
      Swal.fire(
        '¡Advertencia!',
        '¡Campos incorrectos!',
        'info'
      )
      return;
}else{

    this.registro.actualizarPassword(email,password).subscribe((res) => {

      console.log(res);

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion(); 
       return;
    }

      if(res=='Agregado'){
        console.log(res);
        Swal.fire(
              '¡Aviso!',
              '¡Contraseña actualizada correctamente!',
              'success'
            )
            this.router.navigate(['/dashboard']);
      }else{
        console.log(res);
        Swal.fire(
          '¡El usuario no existe!',
          '¡La contraseña no fue actualizada!',
          'error'
        )
      }
     },(err : HttpErrorResponse)=>{
       console.log(err);
    });

  }

  }
///////////////verificacion del cargo//////////////////////////  

  verificarcargo(){
    this.correo=localStorage.getItem('email');
    this.cargo=localStorage.getItem('cargo');

    if(this.cargo=="Docente"){
          this.bandera=false;
    }else{
      this.bandera=true;
    }
 
  }

}
